import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import styled from 'styled-components'

import {
  stopTimer
} from '../../../duck/operations'

const Main = styled.div``

class TimerComponent extends Component {
  formatTime(time) {
    if (time !== undefined) {
      const hours = Math.floor(time / 3600) % 24
      const minutes = Math.floor(time / 60) % 60
      const seconds = time % 60

      const minutes_str = hours > 0 ? `${minutes}`.padStart(2, '0') :  `${minutes}`.padStart(1, '0')
      const seconds_str = `${seconds}`.padStart(2, '0')

      return hours > 0 ? `${hours}:${minutes_str}:${seconds_str}` : `${minutes_str}:${seconds_str}`
    } else {
      return '--:--'
    }
  }

  render() {
    return (
      <Main className={this.props.className}>
        {this.formatTime(this.props.dynamic === true ? this.props.position : this.props.duration)}
      </Main>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    position: state.position,
    duration: state.duration
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators( { stopTimer }, dispatch)
}

export const Timer = connect(mapStateToProps, mapDispatchToProps)(TimerComponent)



// WEBPACK FOOTER //
// ./src/components/player/utils/timer.js